<template>
  <div class="forgot-box">
    <div class="forgot-content">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="Username" prop="username">
          <el-input
            v-model="ruleForm.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Token" prop="token">
          <el-col :span="12">
            <el-input 
              v-model="ruleForm.token"
            ></el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="6">
            <el-button  
              :disabled="isLocked"
              @click="getCode()">
              Get Verification token
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" class="forgot-reset">Reset</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCodeAPI, forgotPassword } from 'network/password'

export default {
  name: "ForgotPassword",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the username'));
      } else {
        callback();
      }
    };
    const validateToken = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the token'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        callback();
      }
    };
    return {
      isLocked: false,
      ruleForm: {
        username: '',
        token: '',
        password: '',
        
      },
      rules: {
        username: [
          { required: true, validator: validateUsername, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        token: [
          { required: true, validator: validateToken, trigger: 'blur' },
          { min: 6, message: "Please enter six digits.", trigger: 'blur'},
          { max: 6, message: "Please enter six digits.", trigger: 'blur'}
        ]
      }
    };
  },
  components: {},
  methods: {
    getCode() {
      const username = this.ruleForm.username
      if (username === "") {
        this.$message.error("Please input username.");
        return
      }

      this.isLocked = true
      setTimeout(() => {
        this.isLocked = false
      }, 5000)

      const subData = {
        username: username
      }
      getCodeAPI(subData)
        .then( data => {
          if (data.status === 200) {
            this.$message.success("The verification code has been sent to your email address.")
          }
        })
        .catch(err => {
          // this.$message.error("Please enter the correct username.")
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const subData = {
            username: this.ruleForm.username,
            password: this.ruleForm.password,
            verification_code: this.ruleForm.token
          }

          forgotPassword(subData)
            .then( data => {
              if (data.status === 200) {
                this.$message.success("The password is changed successfully. Please log in");
                this.$refs[formName].resetFields()
                this.$router.push("/login")
              } 
          }).catch( err => {
            // this.$message.error("Please enter the correct usename, token, password.");
          })
        } 
      })
    }
  }
};
</script>

<style scoped>
.forgot-box {
  padding-top: 150px;
  width: 100%;
  height: 100vh;
  background-color: #f3f3f3;
}

.forgot-content {
  margin: 0 auto;
  padding: 42px 130px 50px;
  border: 1px solid #ebedf0;
  width: 800px;
  background-color: #fff;
}
.forgot-reset {
  margin-left: 120px;
}
</style>
